import React from 'react';
import {Button, Col} from 'react-bootstrap';

const CreateUniversalCodeButton = (props) => (
  <Col md={4} style={{textAlign: 'left', marginBottom: '10px'}}>
    <Button bsStyle='info' onClick={props.onClick} style={{marginLeft: 'auto', marginTop:'10px'}}>
      Create Universal Code
    </Button>
  </Col>
)
export default CreateUniversalCodeButton;
